<template>
    <div class="container mt-3">
        <div class="event-create">
            <div class="row">
                <div class="col-md-12 event-background mb-5">

                    <h1 class="mb-4 mt-4 event-heading" v-if="!events">Update Event</h1>
                    <h1 class="mb-4 mt-4 event-heading" v-if="events">Add Event</h1>

                    <form>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Event Title</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter Title"
                                           v-model="eventAdd.event_title" required>
                                </div>
                            </div>
                            <!--<div class="col-md-6">-->
                            <!--<div class="form-group">-->
                            <!--<label><b>Event Url</b></label>-->
                            <!--<input type="text"-->
                            <!--class="form-control"-->
                            <!--placeholder="Enter Url">-->
                            <!--</div>-->
                            <!--</div>-->
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <label><b>Event Start Date</b></label>
                                <base-input addon-left-icon="ni ni-calendar-grid-58">
                                    <flat-picker slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 :config="{allowInput: true}"
                                                 class="form-control datepicker"
                                                 placeholder="Select Date"
                                                 v-model="eventAdd.event_date" required>
                                    </flat-picker>
                                </base-input>
                            </div>
                            <div class="col-md-6">
                                <label><b>Event End Date</b></label>
                                <base-input addon-left-icon="ni ni-calendar-grid-58">
                                    <flat-picker slot-scope="{focus, blur}"
                                                 @on-open="focus"
                                                 @on-close="blur"
                                                 :config="{allowInput: true}"
                                                 class="form-control datepicker"
                                                 placeholder="Select Date"
                                                 v-model="eventAdd.event_date_registration_end" required>
                                    </flat-picker>
                                </base-input>
                            </div>
                        </div>

                        <div class="form-group mb-3">
                            <label><b>Event Description</b></label>
                            <editor v-model="eventAdd.event_description" v-validate="'required|min:16'"
                                    name="event_description"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="event description"></editor>
                            <small v-if="errors.has('event_description')" class="text-danger">
                                {{ errors.first('event_description') }}
                            </small>
                        </div>

                        <div class="form-group mb-3">
                            <label><b>Event Works</b></label>
                            <editor v-model="eventAdd.event_how_it_works" v-validate="'required|min:16'"
                                    name="event_description"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="event works"></editor>
                            <small v-if="errors.has('event_description')" class="text-danger">
                                {{ errors.first('event_works') }}
                            </small>
                        </div>

                        <div class="form-group mb-3">
                            <label><b>Event Agenda</b></label>
                            <editor v-model="eventAdd.event_agenda"
                                    name="event_agenda"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="event agenda"></editor>
                            <small v-if="errors.has('event_agenda')" class="text-danger">
                                {{ errors.first('event_agenda') }}
                            </small>
                        </div>

                        <div class="form-group mb-3">
                            <label><b>Event Venue</b></label>
                            <editor v-model="eventAdd.event_venue"
                                    name="event_venue"
                                    api-key="API_KEY" :init="{plugins: 'wordcount'}"
                                    data-vv-as="event venue"></editor>
                            <small v-if="errors.has('event_venue')" class="text-danger">
                                {{ errors.first('event_venue') }}
                            </small>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Event Fee</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter Fee"
                                           v-model="eventAdd.event_fee" required>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Event City</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter City"
                                           v-model="eventAdd.event_city" required>
                                </div>
                            </div>
                        </div>

                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label><b>Event Location</b></label>
                                    <input type="text"
                                           class="form-control"
                                           placeholder="Enter Location"
                                           v-model="eventAdd.event_location" required>
                                </div>
                            </div>
                            <div class="col-md-6"></div>
                        </div>
                        <div class="mb-5 mt-3">
                            <button type="button"
                                    class="btn btn-primary"
                                    v-if="!events"
                                    @click="update_Event()">UPDATE EVENT
                            </button>
                            <button type="button" class="btn btn-primary" v-if="events" @click="add_Event()">ADD EVENT
                            </button>
                            <router-link :to="{name: 'website-events'}" class="btn btn-secondary">Back</router-link>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Editor from "@tinymce/tinymce-vue";
import axios from "axios";
import _ from "lodash";

export default {
  name: "CreateEvent",
  components: { flatPicker, Editor },
  data() {
    return {
      eventAdd: {},
      events: true
    };
  },
  methods: {
    add_Event: function() {
      this.eventAdd.access_token = localStorage.getItem("access_token");
      console.log(this.eventAdd);
      axios({
        method: "POST",
        url: "admin/events/new",
        data: this.eventAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Event Added Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          let errors = error.response.data.error;
          for (let error in errors) {
            this.$noty.error("Error: " + _.startCase(errors[error][0]));
          }
        }
      );
    },
    getSingle_Events() {
      axios({
        url:
          "/admin/events/" +
          this.$route.params.event_id +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.eventAdd = result.data.event;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    update_Event: function() {
      this.eventAdd.access_token = localStorage.getItem("access_token");
      axios({
        method: "PUT",
        url: "/admin/events/update/" + this.$route.params.event_id,
        data: this.eventAdd,
        headers: {
          "content-type": "application/json"
        }
      }).then(
        result => {
          if (result.data.status === true) {
            this.$swal("Event Updated Successfully", "", "success");
          }
        },
        error => {
          this.$swal("Error", "There was an error. Please try again", "error");
          let errors = error.response.data.error;
          for (let error in errors) {
            this.$noty.error("Error: " + _.startCase(errors[error][0]));
          }
        }
      );
    }
  },
  mounted: function() {
    if (this.$route.params.event_id > 0) {
      this.events = false;
      this.getSingle_Events();
    } else {
      this.eventAdd = {};
      this.events = true;
    }
  }
};
</script>

<style lang="scss">
.event-create {
  padding-right: 20px;
  padding-left: 20px;
  .event-heading {
    font-size: 35px;
  }
  .form-control:focus {
    box-shadow: 0 0 0 0.2rem rgb(255, 255, 255);
  }
  .event-background {
    border-radius: 4px;
    box-shadow: 0 3px 3px 0 rgba(0, 0, 0, 0.08);
    border: solid 0.5px #e8ebf2;
    background-color: #ffffff;
  }
}
</style>
